import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getJobList(data) {
  return request({
    url: URL.act.financeMange.advQueryFinanceList,
    method: 'post',
    data
  })
}
// 结转查询
export function queryJobPageable2ClosingAccountHandler(data) {
  return request({
    url: URL.act.financeMange.queryJobPageable2ClosingAccountUrl,
    method: 'post',
    data
  })
}
// 从其他模块跳转到财务审核详情，根据jobNo获取JobList
export function getJobList4External(data) {
  return request({
    url: URL.act.financeMange.external2detailFinanceList,
    method: 'post',
    data
  })
}

export function exportExcel4FinanceManage(data) {
  return request({
    url: URL.act.financeMange.exportExcel4FinanceManage,
    method: 'post',
    responseType: 'blob',
    data
  })
}

export function exportExcel4CarryForward(data) {
  return request({
    url: URL.act.financeMange.exportExcel4CarryForward,
    method: 'post',
    data
  })
}

export function queryTotalProfit(data) {
  return request({
    url: URL.act.financeMange.queryTotalProfit,
    method: 'post',
    data
  })
}

export function jobAccountVerify(data) {
  return request({
    url: URL.act.financeMange.jobAccountVerify,
    method: 'post',
    data
  })
}
export function jobSingleAccountVerify(data) {
  return request({
    url: URL.act.financeMange.jobSingleAccountVerify,
    method: 'post',
    data
  })
}

export function jobClosingAccountFunc(data) {
  return request({
    url: URL.act.financeMange.jobClosingAccountUrl,
    method: 'post',
    data
  })
}

export function updateChangeState(jobKeys, params) {
  return request({
    url: URL.act.financeMange.updateChangeState,
    method: 'post',
    data: jobKeys,
    params
  })
}

export function jobClosingAccountRollbackFunc(jobKeys, location) {
  return request({
    url: URL.act.financeMange.jobClosingAccountRollbackUrl,
    method: 'post',
    data: jobKeys,
    params: { location }
  })
}

export function jobVerifyByRange(data) {
  return request({
    url: URL.act.financeMange.jobVerifyByRange,
    method: 'post',
    data
  })
}

export function countJobVerifyByRange(data) {
  return request({
    url: URL.act.financeMange.countJobVerifyByRange,
    method: 'post',
    data
  })
}

export function updateProvisioned(data, params) {
  return request({
    url: URL.act.financeMange.updateProvisioned,
    method: 'post',
    data,
    params
  })
}

export function jobProvisionedFunc(data, params) {
  return request({
    url: URL.act.financeMange.jobProvisionedUrl,
    method: 'post',
    data,
    params
  })
}

export function updateBusinessDate(jobKeys, businessDate) {
  return request({
    url: URL.act.financeMange.updateBusinessDate,
    method: 'post',
    data: jobKeys,
    params: { businessDate }
  })
}
export function updateBusinessAdjustment({ jobKeys, map }) {
  return request({
    url: URL.act.financeMange.updateBusinessAdjustment,
    method: 'post',
    data: { jobKeys, map }
  })
}
// 取消财务审核
export function jobAccountVerifyRollback(jobKeys, branchId, location, rejectReason) {
  return request({
    url: URL.act.financeMange.jobAccountVerifyRollback,
    method: 'post',
    data: jobKeys,
    params: { branchId, location, rejectReason }
  })
}

// 取消财务审核
export function jobSingleAccountVerifyRollback(jobKeys, branchId, location, rejectReason) {
  return request({
    url: URL.act.financeMange.jobSingleAccountVerifyRollback,
    method: 'post',
    data: jobKeys,
    params: { branchId, location, rejectReason }
  })
}

// 审核费用接口
export function batchUpdateChargeState(uuidAccountDateMap, chargeState) {
  return request({
    url: URL.act.financeMange.batchUpdateChargeState,
    method: 'post',
    data: uuidAccountDateMap,
    params: { chargeState }
  })
}

// 修改财务日期
export function batchUpdateAccountingDate(jobKeys, accountingData, location) {
  return request({
    url: URL.act.financeMange.batchUpdateAccountingDate,
    method: 'post',
    data: jobKeys,
    params: { accountingData, location }
  })
}

// 修改费用财务日期
export function batchUpdateChargeAccountingDate(chargeUuids, accountingData, location) {
  return request({
    url: URL.act.financeMange.batchUpdateChargeAccountingDate,
    method: 'post',
    data: chargeUuids,
    params: { accountingData, location }
  })
}

// 业务费用审核同步云星空
export function jobChargeVerifySyncYXK(jobKey, chargeKeys) {
  if (chargeKeys instanceof Array && chargeKeys.length > 0) {
    chargeKeys = chargeKeys.join(',')
  }
  return request({
    url: URL.act.financeMange.jobChargeVerifySyncYXK,
    method: 'post',
    params: { jobKey, chargeKeys }
  })
}

export function updateJobPigeonholeByJobUuid(jobKeys, pigeonhole) {
  return request({
    url: URL.act.financeMange.updateJobPigeonholeByJobUuid,
    method: 'post',
    data: jobKeys,
    params: { pigeonhole }
  })
}

// 维凯-取消审核推送财务取消审核接口
export function wkVerifyRollbackPush(data) {
  return request({
    url: URL.act.apiInterface.wkVerifyRollbackPushUrl,
    method: 'post',
    data
  })
}
